import React, { createContext } from 'react'
import { User } from 'firebase'

export enum AuthState {
  signedOut,
  signedIn,
  signingIn
}

export enum UserType {
  migrant,
  vendor
}

export interface CustomClaims {
  userType: UserType
  vendorId?: string
  role?: {
    id: string
    name: string
    permissions: {
      [key: string]: {
        read: boolean
        write: boolean
      }
    }
  }
}

export interface AuthContextInterface {
  authState: AuthState
  user: User | null
  userType: UserType
  setUserType: React.Dispatch<React.SetStateAction<UserType>>
  customClaims: CustomClaims | null
  setCustomClaims: React.Dispatch<React.SetStateAction<CustomClaims | null>>
  redirectTo: string | null
  setRedirectTo: React.Dispatch<React.SetStateAction<string | null>>
}

export const AuthContext = createContext<AuthContextInterface | null>(null)
